<div class="qb-root">
  <div class="qb-group">
    <div class="qb-group-header">
      <mat-form-field appearance="fill">
        <mat-label>Match</mat-label>
        <mat-select [ngModel]="getGroupMatchMode(root)" (ngModelChange)="setGroupMatchMode(root, $event)">
          <mat-option [value]="'all'">All</mat-option>
          <mat-option [value]="'any'">Any</mat-option>
          <mat-option [value]="'not_all'">Not All</mat-option>
          <mat-option [value]="'not_any'">Not Any</mat-option>
        </mat-select>
      </mat-form-field>

      <span class="qb-spacer"></span>
      <button mat-stroked-button color="lightGreen" (click)="addRule(root)">Add Rule</button>
      <button mat-stroked-button (click)="addGroup(root)">Add Group</button>
    </div>

    <div class="qb-children">
      <ng-container *ngFor="let child of root.children; let i = index">
        <ng-container *ngIf="isRule(child); else groupT">
          <ng-container *ngTemplateOutlet="ruleT; context: {$implicit: child, index: i, parent: root}"></ng-container>
        </ng-container>
        <ng-template #groupT>
          <ng-container *ngTemplateOutlet="groupNodeT; context: {$implicit: child, index: i, parent: root}"></ng-container>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #ruleT let-rule let-i="index" let-parent="parent">
  <div class="qb-node">
    <mat-form-field appearance="fill" class="field">
      <mat-label>Field</mat-label>
      <mat-select [(ngModel)]="rule.fieldId" (selectionChange)="onFieldChanged(rule)">
        <mat-optgroup label="Standard">
          <mat-option *ngFor="let c of standardFields" [value]="c.id">{{ c.name }}</mat-option>
        </mat-optgroup>
        <mat-optgroup label="Device">
          <mat-option *ngFor="let c of deviceFields" [value]="c.id">{{ c.name }}</mat-option>
        </mat-optgroup>
        <mat-optgroup label="Custom">
          <mat-option *ngFor="let c of customFields" [value]="c.id">{{ c.name }}</mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="operator" *ngIf="rule.type">
      <mat-label>Operator</mat-label>
      <mat-select [(ngModel)]="rule.operator" (selectionChange)="onOperatorChanged(rule)">
        <mat-option *ngFor="let op of getOperatorsForType(rule.type)" [value]="op.key">{{ op.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container [ngSwitch]="rule.type">
      <mat-form-field appearance="fill" class="value" *ngSwitchCase="'String'">
        <mat-label>Value</mat-label>
        <input matInput [(ngModel)]="rule.value" (ngModelChange)="emitWhere()" />
      </mat-form-field>

      <div class="value" *ngSwitchCase="'Number'">
        <mat-form-field appearance="fill" *ngIf="rule.operator !== 'between'">
          <mat-label>Value</mat-label>
          <input matInput type="number" [(ngModel)]="rule.value" (ngModelChange)="emitWhere()" />
        </mat-form-field>
        <div class="between" *ngIf="rule.operator === 'between'">
          <mat-form-field appearance="fill">
            <mat-label>Min</mat-label>
            <input matInput type="number" [(ngModel)]="rule.value[0]" (ngModelChange)="emitWhere()" />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Max</mat-label>
            <input matInput type="number" [(ngModel)]="rule.value[1]" (ngModelChange)="emitWhere()" />
          </mat-form-field>
        </div>
      </div>

      <ng-container *ngSwitchCase="'Integer'">
        <div class="value">
          <mat-form-field appearance="fill" *ngIf="rule.operator !== 'between'">
            <mat-label>Value</mat-label>
            <input matInput type="number" [(ngModel)]="rule.value" (ngModelChange)="emitWhere()" />
          </mat-form-field>
          <div class="between" *ngIf="rule.operator === 'between'">
            <mat-form-field appearance="fill">
              <mat-label>Min</mat-label>
              <input matInput type="number" [(ngModel)]="rule.value[0]" (ngModelChange)="emitWhere()" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Max</mat-label>
              <input matInput type="number" [(ngModel)]="rule.value[1]" (ngModelChange)="emitWhere()" />
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Float'">
        <div class="value">
          <mat-form-field appearance="fill" *ngIf="rule.operator !== 'between'">
            <mat-label>Value</mat-label>
            <input matInput type="number" [(ngModel)]="rule.value" />
          </mat-form-field>
          <div class="between" *ngIf="rule.operator === 'between'">
            <mat-form-field appearance="fill">
              <mat-label>Min</mat-label>
              <input matInput type="number" [(ngModel)]="rule.value[0]" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Max</mat-label>
              <input matInput type="number" [(ngModel)]="rule.value[1]" />
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <div class="value" *ngSwitchCase="'Boolean'">
        <mat-button-toggle-group [(ngModel)]="rule.operator">
          <mat-button-toggle value="is_true">True</mat-button-toggle>
          <mat-button-toggle value="is_false">False</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="value" *ngSwitchCase="'Date'">
        <mat-form-field appearance="fill" *ngIf="rule.operator !== 'between'">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="rule.value" (ngModelChange)="emitWhere()">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="between" *ngIf="rule.operator === 'between'">
          <mat-form-field appearance="fill">
            <mat-label>Start</mat-label>
            <input matInput [matDatepicker]="pickerStart" [(ngModel)]="rule.value[0]" (ngModelChange)="emitWhere()">
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>End</mat-label>
            <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="rule.value[1]" (ngModelChange)="emitWhere()">
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <button mat-icon-button class="icon-btn" (click)="removeNode(parent, i)" matTooltip="Remove">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #groupNodeT let-group let-i="index" let-parent="parent">
  <div class="qb-node">
    <div class="qb-group">
      <div class="qb-group-header">
        <mat-form-field appearance="fill">
          <mat-label>Match</mat-label>
          <mat-select [ngModel]="getGroupMatchMode(group)" (ngModelChange)="setGroupMatchMode(group, $event)">
            <mat-option [value]="'all'">All</mat-option>
            <mat-option [value]="'any'">Any</mat-option>
            <mat-option [value]="'not_all'">Not All</mat-option>
            <mat-option [value]="'not_any'">Not Any</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="qb-spacer"></span>
        <button mat-stroked-button color="lightGreen" (click)="addRule(group)">Add Rule</button>
        <button mat-stroked-button (click)="addGroup(group)">Add Group</button>
        <button mat-icon-button (click)="removeNode(parent, i)" matTooltip="Remove group"><mat-icon>delete</mat-icon></button>
      </div>
      <div class="qb-children">
        <ng-container *ngFor="let child of group.children; let j = index">
          <ng-container *ngIf="isRule(child); else nestedGroupT">
            <ng-container *ngTemplateOutlet="ruleT; context: {$implicit: child, index: j, parent: group}"></ng-container>
          </ng-container>
          <ng-template #nestedGroupT>
            <ng-container *ngTemplateOutlet="groupNodeT; context: {$implicit: child, index: j, parent: group}"></ng-container>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>


